export const items = [
  {
    Question:
      'A historian ought to be exact, sincere and impartial; free from passion, unbiased by interest, fear, resentment or affection; and faithful to the truth, which is the mother of history the preserver of great actions, the enemy of oblivion, the witness of the past, the director of the future.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_07/pdf/35',
      },
    ],
  },
  {
    Question:
      'A people and their religion must be judged by social standards based on social ethics. No other standard would have any meaning if religion is held to be necessary good for the well-being of the people.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/109',
      },
    ],
  },
  {
    Question:
      'An ideal society should be mobile, should be full of channels for conveying a change taking place in one part to other parts. In an ideal society there should be many interests consciously communicated and shared.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/12',
      },
      {
        Answer: '/books/baws/EN/Volume_02/pdf/11',
      },
    ],
  },
  {
    Question:
      'Anyone who studies working of the system of social economy based on private enterprise and pursuit of personal gain will realise how it undermines, if it does not actually violate the individual rights on which democracy rests. How many have to relinquish their rights in order to gain their living? How many have to subject themselves to be governed by private employers?',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/424',
      },
    ],
  },
  {
    Question:
      'Being grateful has limitations, no man can be grateful at the cost of his dignity, no woman at the cost of her chastity & no country at the cost of its freedom.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/490',
      },
    ],
  },
  {
    Question:
      'Can education destroy caste ? The answer is ‘Yes’ as well as ‘No’. If education is given as it is to-day, education can have no effect on caste. It will remain as it will be. The glaring example of it is the Brahmin Caste. Cent percent of it is educated, nay, majority of it is highly educated. Yet not one Brahmin has shown himself to be against caste. Infact an educated person belonging to the higher caste is more interested after his education to retain the Caste System than when he was not educated. For education gives him an additional interest in the retention of the Caste System namely by opening additional opportunity of getting a bigger job.',
    Response: [
      {
        Answer: ' /books/baws/EN/Volume_17_03/pdf/551',
      },
    ],
  },
  {
    Question:
      'Can education destroy caste ? The answer is ‘Yes’ as well as ‘No’. If education is given as it is to-day, education can have no effect on caste. It will remain as it will be. The glaring example of it is the Brahmin Caste. Cent percent of it is educated, nay, majority of it is highly educated. Yet not one Brahmin has shown himself to be against caste. Infact an educated person belonging to the higher caste is more interested after his education to retain the Caste System than when he was not educated. For education gives him an additional interest in the retention of the Caste System namely by opening additional opportunity of getting a bigger job..1',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/551',
      },
    ],
  },
  {
    Question:
      'Caste cannot be abolished by inter caste dinners or stray instances of inter caste marriages. Caste is a state of mind. It is a disease of mind. The teachings of the Hindu religion are the root cause of this disease. We practice casteism and we observe Untouchability because we are enjoined to do so by the Hindu religion. A bitter thing cannot be made sweet. The taste of anything can be changed. But poison cannot be changed into nectar.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/159',
      },
    ],
  },
  {
    Question:
      "Civilization has never been a continuous process. There were states and societies which at one time had been civilised. In the course of time something happened which made these societies stagnant and decayed. This could be illustrated by India's history itself. There could be no doubt that one of the countries which could boast of ancient civilization is India. When the inhabitants of Europe were living under the barbaric conditions, this country had reached the highest peak of civilization, it had parliamentary institutions when the people of Europe were mere nomads.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/414',
      },
    ],
  },
  {
    Question:
      'Constitutional morality is not a natural sentiment. It has to be cultivated. We must realise that our people have yet to learn it. Democracy in India is only a top dressing on an Indian soil whish is essentially undemocratic.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_13/pdf/94',
      },
    ],
  },
  {
    Question:
      'Cultivation of mind should be the ultimate aim of human existence.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_09/pdf/312',
      },
      {
        Answer: '/books/baws/EN/Volume_09/pdf/312',
      },
    ],
  },
  {
    Question:
      'Democracy is not a Form of Government, but a form of social organisation.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_04/pdf/292',
      },
    ],
  },
  {
    Question:
      'Democracy is not merely a form of Government. It is primarily a mode of associated living, of conjoint communicated experience. It is essentially an attitude of respect and reverence towards our fellow men.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/72',
      },
    ],
  },
  {
    Question:
      'Emerson has said that consistency is a virtue of an ass. No thinking human being can be tied down to a view once expressed in the name of consistency. More important than consistency is responsibility. A responsible person must learn to unlearn what he has learned. A responsible person must have the courage to rethink and change his thoughts. Of course there must be good and sufficient reason for unlearning what he has learned and for recasting his thoughts. There can be no finality in rethinking.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/154',
      },
    ],
  },
  {
    Question:
      'Equality may be a fiction but nonetheless one must accept it as a governing principle.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/73',
      },
    ],
  },
  {
    Question:
      'Ethnologists are of the opinion that men of pure race exist nowhere and that there has been admixture of all races in all parts of the world - especially is this the case with the people if India. Mr. D.R. Bhandarkar has stated: "There is hardly a class or caste in India which has not a foreign strain in it. There is as an admixture of alien blood not only among the warrior classes - the Rajputs and Marathas - but among the Brahmins who are under the happy delusion that they are free from all foreign elements.',
    Response: [
      {
        Answer:
          'Castes in India: Their Mechanism, Genesis and Development Book by B. R. Ambedkar',
      },
      {
        Answer: '/books/baws/EN/Volume_01/pdf/63',
      },
    ],
  },
  {
    Question:
      'Every man must have a philosophy of life, for everyone must have a standard by which to measure his conduct. And philosophy is nothing but a standard by which to measure.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/532',
      },
    ],
  },
  {
    Question:
      'Every man who repeats the dogma of Mill that one country is no fit to rule another country must admit that one class is not fit to rule another class.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/56',
      },
    ],
  },
  {
    Question:
      'For a successful revolution it is not enough that there is discontent. What is required is a profound and thorough conviction of the justice, necessity and importance of political and social rights.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/212',
      },
    ],
  },
  {
    Question:
      "Freedom of mind is the real freedom. A person whose mind is not free though he may not be in chains, is a slave, not a free man. One whose mind is not free, though he may not be in prison, is a prisoner and not a free man. One whose mind is not free though alive, is no better than dead. Freedom of mind is the proof of one's existence.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/157',
      },
    ],
  },
  {
    Question:
      'From the point of view of annihilation of caste, the struggle of the saints did not have any effects on society. The value of a man is axiomatic and self-evident; it does not come to him from the gilding of Bhakti. The saints did not struggle to establish this point. On the contrary their struggle had very unhealthy effect on the depressed classes. It provided the Brahmins with an excuse to silence them by telling them that they would be respected if they attained the status of Chokhamela.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/37',
      },
    ],
  },
  {
    Question:
      "Hero-worship in the sense of expressing our unbound admiration is one thing. To obey the hero is a totally different kind of worship. There is nothing wrong in the former while the latter is no doubt a most pernicious thing. The former is man's respect for which is noble and of which the great men are only an embodiment. The latter is the serf's fealty to his lord. The former is consistent with respect, but the latter is a sign of debasement. The former does not take away one's intelligence to think and independence to act. The latter makes one perfect fool. The former involves no disaster to the state. The latter is a source of positive danger to it.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/245',
      },
    ],
  },
  {
    Question:
      'History bears out the proposition that political revolutions have always been preceded by social and religious revolutions. Social reform in India has few friends and many critics.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/57',
      },
    ],
  },
  {
    Question:
      'History shows that where ethics and economics come in conflict, victory is always with economics. Vested interests have never been known to have willingly divested themselves unless there was sufficient force to compel them.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_09/pdf/226',
      },
    ],
  },
  {
    Question:
      'I am myself a believer in Animas (non-violence). But I make a distinction between Animas and meekness. Meekness is weakness and weakness is voluntarily imposed upon oneself is not a virtue. I am believer in Animas but in the sense defined by the saint Takuma. Takuma has quite rightly said that Animas consisted of two things: (1) love and kindness towards all creatures and (2) destruction of evil doers. The second part of this definition is often lost sight of that the doctrine of Animas becomes so ridiculous.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/317',
      },
    ],
  },
  {
    Question:
      'I feel that the constitution is workable, it is flexible and it is strong enough to hold the country together both in peacetime and in wartime. Indeed, if I may say so, if things go wrong under the new Constitution, the reason will not be that we had a bad Constitution. What we will have to say is that Man was vile.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_13/pdf/103',
      },
    ],
  },
  {
    Question:
      'I hate injustice, tyranny, pompousness and humbug, and my hatred embraces all those who are guilty of them. I want to tell my critics that I regard my feelings of hatred as a real force. They are only the reflexes of love I bear for the causes I believe in and I am in no wise ashamed of it.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/223',
      },
    ],
  },
  {
    Question:
      'I hope that Mr. Gandhi will not drive me to the necessity of making a choice between his life & rights of my people, for I shall never consent to deliver my people bound hand & foot to the orthodox for generations to come.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_09/pdf/346',
      },
    ],
  },
  {
    Question:
      'I measure the progress of a community by the degree of progress which women have achieved.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/311',
      },
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/311',
      },
    ],
  },
  {
    Question:
      "I tell you, religion is for man and not man for religion. If you want to organise, consolidate and be successful in this world, change this religion. The religion that does not recognise you as a human being, or give you water to drink, or allow you to enter in temples is not worthy to be called a religion. The religion that forbids you to receive education and comes in the way of your material advancement is not worthy of the appellation 'religion'. The religion that does not teach its followers to show humanity in dealing with its co-religionists is nothing but a display of a force. The religion that teaches its followers to suffer the touch of animals but not the touch of human beings is not a religion but a mockery. The religion that compels the ignorant to be ignorant and the poor to be poor is not a religion but a visitation!",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/174',
      },
    ],
  },
  {
    Question:
      'In Hinduism, conscience, reason and independent thinking have no scope for development.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/157',
      },
    ],
  },
  {
    Question:
      "In India, 'Bhakti' or what may be called the path of devotion or hero-worship plays a part in politics unequalled in magnitude by the part it plays in the politics of any other of the world. 'Bhakti' in religion may be a road to salvation of the soul. But in politics, 'Bhakti' or hero-worship is a sure road to degradation and to eventual dictatorship.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_13/pdf/1248',
      },
    ],
  },
  {
    Question:
      "India is a peculiar country and her nationalists and patriots are a peculiar people. A patriot and a nationalist in India is one who sees with open eyes his fellow men treated as being less than man. But his humanity does not rise in protest. He knows that men and women for no cause are denied their rights. But it does not prick his civil sense of helpful action. He finds a whole class of people shut out from public employment. But it does not rouse his sense of justice and fair play. Hundreds of evil practices that injure man and society are perceived by him. But they do not sicken him with disgust. The patriot's one cry is power for him and his class. I am glad I do not belong to that class of patriots. I belong to that class which takes its stand on democracy and which seeks to destroy monopoly in every form. Our aim is to realise in practice our ideal of one man one value in all walks of life - political, economical and social.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_02/pdf/619',
      },
    ],
  },
  {
    Question:
      'Indians today are governed by two different ideologies. Their political ideal set in the preamble of the Constitution affirms a life of liberty, equality and fraternity. Their social ideal embodied in their religion denies them.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/531',
      },
    ],
  },
  {
    Question:
      'Indifferentism is the worst kind of disease that can affect people.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/71',
      },
    ],
  },
  {
    Question:
      "It is disgraceful to live at the cost of one's self-respect. Self-respect is the most vital factor in life. Without it, man is a cipher. To live worthily with self-respect, one has to overcome difficulties. It is out of hard and ceaseless struggle alone that one derives strength, confidence and recognition.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/39',
      },
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/39',
      },
    ],
  },
  {
    Question:
      'It is not enough to be electors only. It is necessary to be law-makers; otherwise those who can be law-makers ill be the masters of those who can only be electors.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/266',
      },
    ],
  },
  {
    Question:
      'Law and religion are two forces which govern the conduct of men. At times they act as handmaids to each other. At other times they act as check and counter-check. Of the two forces, Law is personal while religion is impersonal. Law being personal it is capable of being unjust and iniquitous. But religion being impersonal, it can be impartial, it is capable of defeating the inequity committed by law. Religion is believed to ennoble man and not degrade him. Hinduism is an exception.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_05/pdf/108',
      },
    ],
  },
  {
    Question:
      'Learn to live in this world with self-respect. You should always cherish some ambition of doing something in this world. But remember that the age of selflessness has ended. A new epoch is set in. All things are now possible because of your being able to participate in the politics and legislature of your country.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/116',
      },
    ],
  },
  {
    Question:
      'Majorities are of two sorts: (1) communal majority and (2) political majority. A political majority is changeable in its class composition. A political majority grows. A communal majority is born. The admission to a political majority is open. The door to a communal majority is closed. The politics of political majority are free to all to make and unmake. The politics of communal majority are made by its own members born in it.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/183',
      },
      {
        Answer: '/books/baws/EN/Volume_01/pdf/184',
      },
      {
        Answer: '/books/baws/EN/Volume_01/pdf/184',
      },
    ],
  },
  {
    Question:
      "Man is mortal. Everyone has to die some day or the other. But one must resolve to lay down one's life in enriching the noble ideals of self-respect and in bettering one's human life. We are not slaves. Nothing is more disgraceful for a brave man than to live life devoid of self-respect.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/40',
      },
    ],
  },
  {
    Question:
      'My social philosophy may be said to be enshrined in three words: liberty, equality and fraternity. My philosophy has roots in religion and not in political science. I have derived them from the teachings of my master, the Buddha.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/12', //the answer was this "Volume_17_03, Page 12 and Page 553" for this quote and because of the this website was breaking
      },
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/532',
      },
    ],
  },
  {
    Question:
      'Negatively I reject the Hindu social philosophy propounded in Bhagvad Gita, based as it is on the Triguna of Sankhya Philosophy which in my judgement is a cruel perversion of the philosophy of Kapila, and which had made the caste system of graded inequality the law of Hindu social life.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/532',
      },
    ],
  },
  {
    Question:
      'On the 26th January 1950, we are going to enter into a life of contradictions. In politics we will have equality and in social and economic life we will have inequality. In politics we will be recognising the principle of one man one vote and one vote one value. In our social and economic life, we shall by reason of our social and economic structure, continue to deny the principle of one man one value. How long shall we continue to live this life of contradictions? How long shall we continue to deny equality in our social and economic life? If we continue to deny it for long, we will do so only by putting our political democracy in peril. We must remove this contradiction at the earliest possible moment else those who suffer from inequality will blow up the structure of democracy which this Constituent Assembly has so laboriously built up.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_13/pdf/1249',
      },
    ],
  },
  {
    Question:
      'One cannot have any respect or regard for men who take the position of the reformer and then refuse to see the logical consequences of that position, let alone following them out in action.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/48',
      },
    ],
  },
  {
    Question:
      'Our object in framing the Constitution is rally two-fold: (1) To lay down the form of political democracy, and (2) To lay down that our ideal is economic democracy and also to prescribe that every Government whatever is in power shall strive to bring about economic democracy. The directive principles have a great value, for they lay down that our ideal is economic democracy.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_13/pdf/385',
      },
    ],
  },
  {
    Question:
      'Political tyranny is nothing compared to the social tyranny and a reformer who defies society is a more courageous man than a politician who defies Government.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/83',
      },
    ],
  },
  {
    Question:
      'Rights are real only if they are accompanied by remedies. It is no use giving rights if the aggrieved person has no legal remedy to which he can resort when his rights are invaded.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/421',
      },
    ],
  },
  {
    Question: 'Sincerity is the sum of all moral qualities.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/229',
      },
    ],
  },
  {
    Question:
      'The basis of my politics lies in the proposition that the Untouchables are not a sub-division or sub-section of Hindus, and that they are a separate and distinct element in the national life of India.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/281',
      },
    ],
  },
  {
    Question:
      'The idea of fundamental rights has become a familiar one since their enactment in the American Constitution and in the Constitution framed by the Revolutionary France. The idea of making a gift of fundamental rights to every individual is no doubt very laudable. The question is how to make them effective? The prevalent view is that once the rights are enacted in law then they are safeguarded. This again is an unwarranted assumption. As experience proves, rights are protected not by law but by social and moral conscience of the society. If social conscience is such that it is prepared to recognise the rights which law proposes to enact, rights will be safe and secure. But if the fundamental rights are opposed by the community, no Law, no Parliament, no Judiciary can guarantee them in the real sense of the world. What is the use of Fundamental rights to the Untouchables in India? As Burke said, there is no method found for punishing the multitude. Law can punish a single solitary recalcitrant criminal. It can never operate against the whole body of people who choose to defy it. Social conscience is the only safeguard of all rights, fundamental or non-fundamental.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/237',
      },
    ],
  },
  {
    Question:
      'The monopoly has not merely deprived them of their chance of betterment, it has sapped them of what may be called the significance of life. Those downtrodden classes are tired of being governed. They are impatient to govern themselves. This urge of self-realisation in the downtrodden must not be allowed to devolve into class struggle or class war. It would lead to the division of the House. That would indeed be a day of disaster. For, as has been well-said by Abraham Lincoln: "A house divided against cannot stand very long". Therefore the sooner room is made for realisation of their aspiration, the better for the few, the better for the country, the better for the independence and the better for the continuance of its democratic structure. This can only be done by the establishment of equality and fraternity in all walks of life.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_13/pdf/1249',
      },
    ],
  },
  {
    Question:
      'The strength of a society depends upon the presence of points of contacts, possibilities of interaction between different groups that exist in it. These are what Carlyle calls "Organic filaments", i.e. the elastic threads which helps to bring the disintegrating elements together and to reunite them.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/80',
      },
    ],
  },
  {
    Question:
      "The true function of law consists in repairing the faults in society. Unfortunately ancient societies never dared to assume the function of repairing their own defects; consequently they decayed. This country has seen the conflict between ecclesiastical law and secular law long before Europeans sought to challenge the authority of the Pope. Kautilya's Arthshastra lays down the foundation of secular law. In India unfortunately ecclesiastical law triumphed over secular law. In my opinion this was the one of the greatest disasters in the country. The unprogressive nature of the Hindu society was due to the notion that the law cannot be changed.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/414',
      },
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/415',
      },
    ],
  },
  {
    Question:
      'The world owes much to rebels who would dare to argue in the face of the pontiff (high priest) and insist that he is not infallible.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/39',
      },
    ],
  },
  {
    Question:
      'This condition obtains even where there is no slavery in the legal sense. It is found where as in caste system, some persons are forced to carry on the prescribed callings which are not their choice.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_01/pdf/72',
      },
    ],
  },
  {
    Question:
      'This struggle starts as soon as you start claiming equal treatment with others. Had it not been so, there would have been no struggle for the simple reason like serving the chapatis, wearing the super quality clothes, putting on the sacred thread, fetching the water in a metal pot, riding the bridegroom on the horse-back etc. In all these cases, you spend your own money. Why then the high caste Hindus get irritated ? The reason for their anger is very simple, your behaving on par with them insults them. Your status in their eyes is low, you are impure, you must remain at the lowest rung, then alone, they will allow you to live happily. The moment you cross your level, the struggle starts. The instances given above also prove one more fact that the Untouchability is not a short or temporary feature, it is a permanent one. To put it straight, it can be said that the struggle between the Caste Hindus and the Untouchables is a permanent phenomena. It is eternal, because the religion which has placed you at the lowest level of the society is itself eternal, according to the belief of the High Caste people. No change, according to times and circumstances is possible. You are at the lowest rung of the ladder today. You shall remain lowest forever. This means, the struggle between the Hindus and the Untouchables shall continue forever. ',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/147',
      },
    ],
  },
  {
    Question:
      "To open or not to open the temples is a question for you to consider & not for me to agitate. If u think it is bad manners not to believe in the sanctity of human beings, then throw open the doors & be a gentleman, but if u wish to remain a orthodox Hindu then shut the doors & damn yourself, for I don't care to come. We are Indians, firstly & lastly",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_01/pdf/223',
      },
      {
        Answer: '/books/baws/EN/Volume_17_01/pdf/223',
      },
    ],
  },
  {
    Question:
      "Walter Bagehot defined democracy as ' Government by discussion'. Abraham Lincoln defined democracy as ' A Government of the people, by the people and for the people'.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/504',
      },
    ],
  },
  {
    Question:
      'We must begin by acknowledging that there is a complete absence of two things in Indian Society. One of these is equality. On the social plane we have an India based on the principles of graded inequality, which means elevation for some and degradation for others. On the economic plane we have a society in which there are some who have immense wealth as against many who live in abject poverty.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_13/pdf/1249',
      },
    ],
  },
  {
    Question:
      'What are we having this liberty for? We are having this liberty in order to reform our social system, which is full of inequality, discrimination and other things, which conflict with our fundamental rights.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_03/pdf/111',
      },
    ],
  },
  {
    Question:
      'What is the proof to judge that the flame of mental freedom is not extinguished in the mind of person? To whom can we say that his mind is free. I call him free who with his conscience awake realises his rights, responsibilities and duties. He who is not a slave of circumstances and is always ready and striving to change them in his flavor, I call him free. One who is not a slave of usage, customs, of meaningless rituals and ceremonies, of superstitions and traditions; whose flame of reason has not been extinguished, I call him a free man. He who has not surrendered his free will and abdicated his intelligence and independent thinking, who does not blindly act on the teachings of others, who does not blindly accept anything without critically analysing and examining its veracity and usefulness, who is always prepared to protect his rights, who is not afraid of ridicule and unjust public criticism, who has a sound conscience and self-respect so as not become a tool in the hands of others, I call him a free man. He who does not lead his life under the direction of others, who sets his own goal of life according to his own reasoning and decides for himself as to how and in what way life should be lead, is a free man. In short, who is a master of his own free will, him alone I call a free man',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_03/pdf/157',
      },
    ],
  },
  {
    Question:
      'What we must do is not to content ourselves with mere political democracy. We must make our political democracy a social democracy as well. Political democracy cannot last unless there is at the base of it, a social democracy. What does social democracy mean? It means a way of life which recognises liberty, equality and fraternity as the principles of life. These principles of liberty, equality and fraternity are not to be treated as separate items. They form a union in the sense that, to divorce one from the other is to defeat the very purpose of democracy. Liberty cannot be divorced from equality, nor can liberty and equality be divorced from fraternity.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_13/pdf/1249',
      },
      {
        Answer: '/books/baws/EN/Volume_13/pdf/1250',
      },
    ],
  },
  {
    Question:
      'Without social union, political unity is difficult to be achieved. If achieved, it would be as precarious as a summer sapling, liable to be uprooted by the gust of wind. With mere political unity, India may be a state. But to be a state is not to be a nation and a state which is not a nation has small prospects of survival in the struggle of existence. This is especially true where nationalism - the most dynamic force of modern times, is seeking everywhere to free itself by the destruction and disruption of all mixed states. The danger to a mixed and composite state, therefore lies not so much in external aggression as in the internal resurgence of nationalities which are fragmented, entrapped, suppressed and held against their will.',
    Response: [
      {
        Answer: '/books/baws/EN/Volume_08/pdf/217',
      },
    ],
  },
  {
    Question:
      "himself. Hopelessness leads to lack of enthusiasm. The mind in such cases becomes deceased.... When is enthusiasm created? When one breaths an atmosphere where one is sure of getting the legitimate reward for one's labor, only then one feels enriched by enthusiasm and inspiration.",
    Response: [
      {
        Answer: '/books/baws/EN/Volume_17_02/pdf/144',
      },
    ],
  },
];
